export default {
  // code: '',
  code: 
`
/**
 * @description: We're getting married!
 * @author: Mouse & Cookie
 * @location: 35°38'35.8"N 111°28'11.8"E
 * @date: 2025/10/2
 */
function willYouMarryMe() {
  let boy = 'Mouse';
  let girl = 'Cookie';
  let durationFromFirstMeet = 10; // years

  boy.say('你愿意嫁给我吗?❤️');
  boy.promise('我将会用余生守护你!∞');

  girl.response('我愿意!❤️')

  Utils.generateInvitation(😆,🤗);

  return true;
}

// test all pass`,

  executions: [{
    name:'结婚证书已备',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'良辰吉日已选',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'婚礼场地就绪',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'亲朋好友将至',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'打包ing...',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'上传ing...',
    time: '',
    duration: 0,
    visible: false
  }, {
    name:'部署ing...',
    time: '',
    visible: false
  }],
  barrages: [
    '有情人终成眷属',
    '十年长跑终于修成正果！',
    '你的邀请函真是棒',
    '太赞了',
    '恭喜恭喜🎉🎉🎉🎉',
    '哇哇哇',
    '今晚翻你牌',
    '看朕给你打下的江山',
    '✿✿ヽ(°▽°)ノ✿',
    '你的代码真是棒',
    '😗 😙 😚 😋 ',
    '只要代码写得好，单身永远跑不了'
  ],
}